import React, { useState, useEffect } from "react";
import { Typography, alpha, Container, Box, CardMedia, Divider, CircularProgress } from "@mui/material";
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";
import { format, fromUnixTime } from 'date-fns';
import { es } from 'date-fns/locale';

const DetallesBlogPages = () => {
    const [blog, setBlog] = useState(null);
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    
    const formatearFecha = (fecha) => format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy", { locale: es });

    useEffect(() => {
        const cargarBlog = async () => {
            try {
                const docRef = doc(db, 'blogcalocho', id);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setBlog({ ...docSnap.data(), id: docSnap.id });
                } else {
                    console.log("No existe el documento");
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        cargarBlog();
    }, [id]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
        );
    }

    if (!blog) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return (
        <Box sx={(theme) => ({
            width: '100%',
            backgroundImage: theme.palette.mode === 'light'
                ? 'linear-gradient(180deg, #5d0303, #FFF)'
                : `linear-gradient(#02294F, ${alpha('#090E10', 0.0)})`,
            backgroundSize: 'cover',
            padding: { xs: 2, sm: 4, md: 6 },
        })}>
            <Container sx={{
                pb: { xs: 8, sm: 12, md: 16 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: { xs: 2, sm: 3, md: 4 },
            }}>
                <CardMedia 
                    component="img"
                    sx={{ 
                        width: { xs: '100%', sm: '80%', md: '60%' },
                        marginTop: { xs: '25%', sm: '3%' },
                        height: 'auto',
                        borderRadius: '5%',
                        border: '0.5px solid #f1f1f1',  
                    }}
                    image={blog.imagen || '/placeholder.jpg'}
                    alt={blog.titulo || 'Imagen del blog'}
                />
                <Typography variant="h3" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' }, 
                    marginTop: { xs: '16%', sm: '3%' },
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}>
                    {blog.titulo}
                </Typography>
                <Typography variant="subtitle1" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' },
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                }}>
                    {blog.descripcion}
                </Typography>

                <Divider sx={{ backgroundColor: '#818180', width: '100%', height: '1px', marginY: { xs: 1, sm: 2, md: 3 } }} />

                <Typography color="#0f0f0f" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' }, 
                    marginTop: { xs: '16%', sm: '3%' },
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}>Categoría</Typography>

                <Typography variant="subtitle1" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' },
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                }}>{blog.categoria}</Typography>

                <Divider sx={{ backgroundColor: '#818180', width: '100%', height: '1px', marginY: { xs: 1, sm: 2, md: 3 } }} />

                <Typography color="#0f0f0f" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' }, 
                    marginTop: { xs: '16%', sm: '3%' },
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}>Se publicó el</Typography>

                <Typography variant="subtitle1" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' },
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                }}>{formatearFecha(blog.fecha)}</Typography>

                <Divider sx={{ backgroundColor: '#818180', width: '100%', height: '1px', marginY: { xs: 1, sm: 2, md: 3 } }} />

                <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' }, 
                    marginTop: { xs: '16%', sm: '3%' },
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}>Link</Typography>

                <Typography variant="subtitle1" color="#2b1ee1" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' },
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                }}>{blog.urlarticulo}</Typography>

                <Divider sx={{ backgroundColor: '#818180', width: '100%', height: '1px', marginY: { xs: 1, sm: 2, md: 3 } }} />

                <Typography color="#0f0f0f" fontWeight="bold" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' }, 
                    marginTop: { xs: '16%', sm: '3%' },
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}>Autor</Typography>
                <Typography variant="subtitle1" sx={{ 
                    marginBottom: { xs: '8px', sm: '12px', md: '16px' },
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                }}>{blog.autor}</Typography>
            </Container>
        </Box>
    );
}

export default DetallesBlogPages;
